// Prototype gallery — replace with owner-supplied photography after approval.
// Free-license placeholder images (Pexels/Unsplash), stored locally.

const img = (n) => `/assets/gallery/${n}`;

export const galleryCategories = [
  "All",
  "Feed-In",
  "Knotless",
  "Cornrows",
  "Kids",
  "Protective Styles",
];

export const gallery = [
  { id: "g1", src: img("g-feedin-1.jpg"), style: "Pink Feed-In Ponytail", category: "Feed-In", serviceId: "feed-in-braids", alt: "Close-up of pink and brown feed-in braids" },
  { id: "g2", src: img("g-knotless-1.jpg"), style: "Waist-Length Knotless", category: "Knotless", serviceId: "knotless-braids", alt: "Woman with long knotless box braids among leaves" },
  { id: "g3", src: img("g-cornrows-1.jpg"), style: "Studio Straight-Backs", category: "Cornrows", serviceId: "cornrows", alt: "Woman with neat straight-back cornrows in studio light" },
  { id: "g4", src: img("g-kids-1.jpg"), style: "Kids Pattern Braids", category: "Kids", serviceId: "kids-braids", alt: "Top view of a child's braided pattern style" },
  { id: "g5", src: img("g-protective-1.jpg"), style: "Classic Long Braids", category: "Protective Styles", serviceId: "box-braids", alt: "Back view of long dark protective braids" },
  { id: "g6", src: img("g-feedin-2.jpg"), style: "Sunset Feed-In Blend", category: "Feed-In", serviceId: "feed-in-braids", alt: "Pink and orange feed-in braids with soft bokeh light" },
  { id: "g7", src: img("g-knotless-2.jpg"), style: "Knotless Duo", category: "Knotless", serviceId: "knotless-braids", alt: "Two women posing with neat knotless box braids" },
  { id: "g8", src: img("g-cornrows-2.jpg"), style: "Detailed Cornrow Work", category: "Cornrows", serviceId: "cornrows", alt: "Close-up portrait of detailed cornrow braiding" },
  { id: "g9", src: img("g-protective-2.jpg"), style: "Sculpted Braid Portrait", category: "Protective Styles", serviceId: "stitch-braids", alt: "Grayscale portrait highlighting intricate braided hair" },
  { id: "g10", src: img("g-feedin-3.jpg"), style: "Side-Part Feed-Ins", category: "Feed-In", serviceId: "feed-in-braids", alt: "Smiling woman with side-part feed-in braids" },
  { id: "g11", src: img("g-knotless-3.jpg"), style: "Flowing Knotless Length", category: "Knotless", serviceId: "knotless-braids", alt: "Long flowing knotless braids from behind" },
  { id: "g12", src: img("g-protective-3.jpg"), style: "Elegant Protective Updo", category: "Protective Styles", serviceId: "box-braids", alt: "Elegant woman with styled protective braids" },
];

export const galleryPreview = gallery.slice(0, 8);

